import { makeStyles } from '@material-ui/styles';

export default makeStyles(() => ({
  editor: {
    width: '100%',
  },
  infoText: {
    textAlign: 'right',
    marginTop: 9,
  },
  error: {
    borderColor: 'red',
    borderWidth: 2,
  },
  ckEditor: {
    backgroundColor: 'white',
    borderRadius: 6,
  },
}));
